// extracted by mini-css-extract-plugin
export default {"root":"DataListControl__root--i31HH"};